module.exports = __webpack_public_path__ + "img/FUT_white.4e021a53.png";